<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
// import { useRouter } from 'vue-router'
import { useTranslation } from 'i18next-vue'
import { useAppStore } from '@/stores/AppStore'
import { useClinicRepository } from '@/repositories/clinicRepo'
import { PatientMini } from '@/type/Clinic'
import AvatarDetail from '@components/webapp/AvatarDetail.vue'
import { getFormattedPointExpireDate, getMembercardExpireDate, formatLocalExpireDate } from '@/global'

const { t } = useTranslation()

// const router = useRouter()

const memberCard = computed(() => appStore.memberCard)
const appStore = useAppStore()
const patient = ref<PatientMini | null>(null)
const actived = ref(0)

// calculator
const membercardPointExpire = computed(() => getFormattedPointExpireDate(memberCard.value?.point_expire_date, t))
const membercardExpireDate = computed(() => {
  if (memberCard.value) {
    return getMembercardExpireDate(memberCard.value)
  }
})

// API
const init = async () => {
  if (appStore.patient) {
    patient.value = appStore.patient
    return
  }
  const clinic_repository = useClinicRepository(appStore.clinicUUID)
  patient.value = await clinic_repository.fetchPatientMiniInfo()
  appStore.setPatient(patient.value)
}
// Get data for avatar detail
const fetchMember = async () => {
  if (appStore.memberCard) return
  if (appStore.patient?.uuid) {
    await appStore.setMemberCard()
  }
}

onMounted(async () => {
  try {
    await init()
    await fetchMember()
  } catch (error) {
    console.error(error)
  }
})
</script>

<template>
  <div class="tw-flex tw-justify-end tw-px-5 tw-pt-3">
    <LanguageButton />
  </div>
  <div class="tw-w-full tw-pt-5 tw-px-5 tw-pb-0">
    <!-- member card -->
    <AvatarDetail
      v-if="patient && memberCard && membercardExpireDate"
      :fullname="`${patient.fname} ${patient.lname}`"
      :profile-image="appStore.userProfile.pictureUrl"
      :membercard-name="memberCard.member_card.name"
      :membercard-cash="memberCard.cash"
      :member-point="memberCard.point"
      :member-point-expire="membercardPointExpire"
      :expire-date="`${formatLocalExpireDate(membercardExpireDate)}`"
      @onClick="$emit('onClick', 0)"
    />
    <MemberCard v-if="memberCard" :memberCard="memberCard.member_card.name" />

    <!-- Tab menu order -->
    <TabMenuOrder
      v-if="memberCard && !memberCard.next_level_name"
      class="mx-3 mt-3"
      :member="memberCard"
      :showChevron="false"
    />
    <TabMenuOrder v-else-if="memberCard" class="mx-3 mt-3" :member="memberCard" :showChevron="true" />

    <div>
      <v-card class="tw-w-full tw-p-4 tw-rounded-lg" elevation="0">
        <!-- <tab-menu
          :id="1"
          :name="$t('appointment.title')"
          icon="menu_6"
          icon_blue="menu_blue_6"
          :active="actived"
          size="tw-h-7"
          :warning="false"
        /> -->
        <tab-menu
          :id="2"
          :name="$t('voucher.title')"
          icon="menu_2"
          icon_blue="menu_blue_2"
          :active="actived"
          size="tw-h-4"
          :warning="false"
        />
        <tab-menu
          :id="3"
          :name="$t('membercard.title')"
          icon="menu_3"
          icon_blue="menu_blue_3"
          :active="actived"
          size="tw-h-6"
          :warning="false"
        />
        <tab-menu
          :id="5"
          :name="$t('course.webapp.mycourse')"
          icon="menu_1"
          icon_blue="menu_blue_1"
          :active="actived"
          size="tw-h-8"
          :warning="false"
        />
      </v-card>
    </div>
  </div>
</template>
